import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  transactions: [],
  getTransactions: action(function () {
    SessionStore.startLoading('Loading…', 'Ledger');
    api.get(`/install/${SessionStore.userData.installSid}/users/${SessionStore.userData.userSid}/ledger`)
      .then(response => {
        obx.transactions = response.data.results;
        SessionStore.finishLoading('Ledger');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  blockedUser: false,
  liveProctoringBlocked: false,
  handleBlockedUser: action(function(fullBlock) {
    obx.liveProctoringBlocked = true;
    if (fullBlock) {
      obx.blockedUser = true;
      window.location.href = '/#/unauthorized';
    }
  })
})

export default obx;


// WEBPACK FOOTER //
// ./src/app/stores/UserStore.js